/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "నిన్న",
        "-2": "మొన్న",
        "0": "ఈ రోజు",
        "1": "రేపు",
        "2": "ఎల్లుండి",
        "future": {
          "one": "{0} రోజులో",
          "other": "{0} రోజుల్లో"
        },
        "past": {
          "one": "{0} రోజు క్రితం",
          "other": "{0} రోజుల క్రితం"
        }
      },
      "day-narrow": {
        "-1": "నిన్న",
        "-2": "మొన్న",
        "0": "ఈ రోజు",
        "1": "రేపు",
        "2": "ఎల్లుండి",
        "future": {
          "one": "{0} రోజులో",
          "other": "{0} రోజుల్లో"
        },
        "past": {
          "one": "{0} రోజు క్రితం",
          "other": "{0} రోజుల క్రితం"
        }
      },
      "day-short": {
        "-1": "నిన్న",
        "-2": "మొన్న",
        "0": "ఈ రోజు",
        "1": "రేపు",
        "2": "ఎల్లుండి",
        "future": {
          "one": "{0} రోజులో",
          "other": "{0} రోజుల్లో"
        },
        "past": {
          "one": "{0} రోజు క్రితం",
          "other": "{0} రోజుల క్రితం"
        }
      },
      "hour": {
        "0": "ఈ గంట",
        "future": {
          "one": "{0} గంటలో",
          "other": "{0} గంటల్లో"
        },
        "past": {
          "one": "{0} గంట క్రితం",
          "other": "{0} గంటల క్రితం"
        }
      },
      "hour-narrow": {
        "0": "ఈ గంట",
        "future": {
          "one": "{0} గం.లో",
          "other": "{0} గం.లో"
        },
        "past": {
          "one": "{0} గం. క్రితం",
          "other": "{0} గం. క్రితం"
        }
      },
      "hour-short": {
        "0": "ఈ గంట",
        "future": {
          "one": "{0} గం.లో",
          "other": "{0} గం.లో"
        },
        "past": {
          "one": "{0} గం. క్రితం",
          "other": "{0} గం. క్రితం"
        }
      },
      "minute": {
        "0": "ఈ నిమిషం",
        "future": {
          "one": "{0} నిమిషంలో",
          "other": "{0} నిమిషాల్లో"
        },
        "past": {
          "one": "{0} నిమిషం క్రితం",
          "other": "{0} నిమిషాల క్రితం"
        }
      },
      "minute-narrow": {
        "0": "ఈ నిమిషం",
        "future": {
          "one": "{0} నిమి.లో",
          "other": "{0} నిమి.లో"
        },
        "past": {
          "one": "{0} నిమి. క్రితం",
          "other": "{0} నిమి. క్రితం"
        }
      },
      "minute-short": {
        "0": "ఈ నిమిషం",
        "future": {
          "one": "{0} నిమి.లో",
          "other": "{0} నిమి.లో"
        },
        "past": {
          "one": "{0} నిమి. క్రితం",
          "other": "{0} నిమి. క్రితం"
        }
      },
      "month": {
        "-1": "గత నెల",
        "0": "ఈ నెల",
        "1": "తదుపరి నెల",
        "future": {
          "one": "{0} నెలలో",
          "other": "{0} నెలల్లో"
        },
        "past": {
          "one": "{0} నెల క్రితం",
          "other": "{0} నెలల క్రితం"
        }
      },
      "month-narrow": {
        "-1": "గత నెల",
        "0": "ఈ నెల",
        "1": "తదుపరి నెల",
        "future": {
          "one": "{0} నెలలో",
          "other": "{0} నెలల్లో"
        },
        "past": {
          "one": "{0} నెల క్రితం",
          "other": "{0} నెలల క్రితం"
        }
      },
      "month-short": {
        "-1": "గత నెల",
        "0": "ఈ నెల",
        "1": "తదుపరి నెల",
        "future": {
          "one": "{0} నెలలో",
          "other": "{0} నెలల్లో"
        },
        "past": {
          "one": "{0} నెల క్రితం",
          "other": "{0} నెలల క్రితం"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "గత త్రైమాసికం",
        "0": "ఈ త్రైమాసికం",
        "1": "తదుపరి త్రైమాసికం",
        "future": {
          "one": "{0} త్రైమాసికంలో",
          "other": "{0} త్రైమాసికాల్లో"
        },
        "past": {
          "one": "{0} త్రైమాసికం క్రితం",
          "other": "{0} త్రైమాసికాల క్రితం"
        }
      },
      "quarter-narrow": {
        "-1": "గత త్రైమాసికం",
        "0": "ఈ త్రైమాసికం",
        "1": "తదుపరి త్రైమాసికం",
        "future": {
          "one": "{0} త్రైమాసికంలో",
          "other": "{0} త్రైమాసికాల్లో"
        },
        "past": {
          "one": "{0} త్రైమా. క్రితం",
          "other": "{0} త్రైమా. క్రితం"
        }
      },
      "quarter-short": {
        "-1": "గత త్రైమాసికం",
        "0": "ఈ త్రైమాసికం",
        "1": "తదుపరి త్రైమాసికం",
        "future": {
          "one": "{0} త్రైమా.లో",
          "other": "{0} త్రైమా.ల్లో"
        },
        "past": {
          "one": "{0} త్రైమా. క్రితం",
          "other": "{0} త్రైమా. క్రితం"
        }
      },
      "second": {
        "0": "ప్రస్తుతం",
        "future": {
          "one": "{0} సెకనులో",
          "other": "{0} సెకన్లలో"
        },
        "past": {
          "one": "{0} సెకను క్రితం",
          "other": "{0} సెకన్ల క్రితం"
        }
      },
      "second-narrow": {
        "0": "ప్రస్తుతం",
        "future": {
          "one": "{0} సెక.లో",
          "other": "{0} సెక. లో"
        },
        "past": {
          "one": "{0} సెక. క్రితం",
          "other": "{0} సెక. క్రితం"
        }
      },
      "second-short": {
        "0": "ప్రస్తుతం",
        "future": {
          "one": "{0} సెకనులో",
          "other": "{0} సెకన్లలో"
        },
        "past": {
          "one": "{0} సెక. క్రితం",
          "other": "{0} సెక. క్రితం"
        }
      },
      "week": {
        "-1": "గత వారం",
        "0": "ఈ వారం",
        "1": "తదుపరి వారం",
        "future": {
          "one": "{0} వారంలో",
          "other": "{0} వారాల్లో"
        },
        "past": {
          "one": "{0} వారం క్రితం",
          "other": "{0} వారాల క్రితం"
        }
      },
      "week-narrow": {
        "-1": "గత వారం",
        "0": "ఈ వారం",
        "1": "తదుపరి వారం",
        "future": {
          "one": "{0} వారంలో",
          "other": "{0} వారాల్లో"
        },
        "past": {
          "one": "{0} వారం క్రితం",
          "other": "{0} వారాల క్రితం"
        }
      },
      "week-short": {
        "-1": "గత వారం",
        "0": "ఈ వారం",
        "1": "తదుపరి వారం",
        "future": {
          "one": "{0} వారంలో",
          "other": "{0} వారాల్లో"
        },
        "past": {
          "one": "{0} వారం క్రితం",
          "other": "{0} వారాల క్రితం"
        }
      },
      "year": {
        "-1": "గత సంవత్సరం",
        "0": "ఈ సంవత్సరం",
        "1": "తదుపరి సంవత్సరం",
        "future": {
          "one": "{0} సంవత్సరంలో",
          "other": "{0} సంవత్సరాల్లో"
        },
        "past": {
          "one": "{0} సంవత్సరం క్రితం",
          "other": "{0} సంవత్సరాల క్రితం"
        }
      },
      "year-narrow": {
        "-1": "గత సం.",
        "0": "ఈ సం.",
        "1": "తదుపరి సం.",
        "future": {
          "one": "{0} సం.లో",
          "other": "{0} సం.ల్లో"
        },
        "past": {
          "one": "{0} సం. క్రితం",
          "other": "{0} సం. క్రితం"
        }
      },
      "year-short": {
        "-1": "గత సంవ.",
        "0": "ఈ సంవ.",
        "1": "తదుపరి సంవ.",
        "future": {
          "one": "{0} సం.లో",
          "other": "{0} సం.ల్లో"
        },
        "past": {
          "one": "{0} సం. క్రితం",
          "other": "{0} సం. క్రితం"
        }
      }
    },
    "locale": "te"
  });
}